<template>
  <div class="drivingPermits">
    <van-popup
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="header">
        <div class="title">您的车辆归属地需上传行驶证才能继续处理</div>
        <van-icon name="cross" @click="close" color="#383838" size="0.3rem" />
      </div>
      <div class="content">
        <van-uploader v-if="!formData.drivingLicenseOssPath" accept="image/*" :after-read="afterRead" class="img">
          <img src="@/assets/img/ticket/drivingPermits.png" alt="">
        </van-uploader>
        <div v-if="formData.drivingLicenseOssPath" class="img"><img :src="url" alt=""></div>
        <van-uploader v-if="formData.drivingLicenseOssPath" accept="image/*" :after-read="afterRead" :max-size="10 * 1024 * 1024" @oversize="onOversize" class="img">
          <div class="uploadInfo">点击重新上传</div>
        </van-uploader>
        <div class="btn">
          <van-button :disabled="!formData.drivingLicenseOssPath" type="info" @click="submit" size="large">继续处理</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import UploadHelper from "@/common/upload-helper.js";
import { upload } from "@/utils/oss.js";
import { getThumbnailImg } from "@/utils/oss";
export default {
  name: "",
  components: {
  },
  props: {
    isDriving: {
      type: Boolean
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      formData: {
        drivingLicenseOssPath: ''
      },
      url: ''
    }
  },
  watch: {
    isDriving(val) {
      this.show = val
    }
  },
  methods: {
    onOversize() {
      this.$toast('文件大小不能超过10M')
    },
    async afterRead(file) {
      if(file.file.size > 10 * 1024 * 1024){
        this.$toast('文件大小不能超过10M')
        return
      }
      this.loading = true;
      file.status = 'uploading';
      file.message = '上传中...';
      const res = await UploadHelper(file.file);
      if (!res.accessUrl) {
        this.$toast("图片上传失败");
        return;
      }
      this.loading = false;
      this.formData.drivingLicenseOssPath = res.picId
      this.url = res.accessUrl
    },
    submit() {
      this.show = false
      this.$emit('submit', this.formData)
    },
    close() {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
.drivingPermits{
  .header{
    height: 1rem;
    line-height: 1rem;
    border-bottom: 1px solid #F4F6F7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    box-sizing: border-box;
    .title{
      color: #383838;
      font-size: 0.32rem;
    }
  }
  .content{
    .img{
      display: flex;
      justify-content: center;
      margin: 0.5rem 0 0.2rem;
      img{
        width: 5rem;
        max-height: 60vh;
        object-fit: contain;
      }
    }
    .uploadInfo{
      font-size: 0.26rem;
      text-align: center;
      margin: 0.2rem 0;
      color: #787878;
    }
    .btn{
      // position: fixed;
      // bottom: 0.3rem;
      width: 100vw;
      height: 1.5rem;
      line-height: 1.2rem;
      padding: 0 0.3rem;
      box-sizing: border-box;
      /deep/ .van-button{
        border-radius: 0.16rem;
      }
    }
  }
}
</style>